var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main_box"},[_c('div',{staticClass:"fixed_box",on:{"click":_vm.goContact}},[_vm._v("Contact Us")])])])}
var staticRenderFns = []

export { render, staticRenderFns }